// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-keys {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

.license-keys h3 {
	margin-bottom: 20px;
	color: #333;
	font-size: 1.5rem;
}

.error-message {
	background: #f8d7da;
	color: #721c24;
	border: 1px solid #f5c6cb;
	border-radius: 6px;
	padding: 15px;
	margin-bottom: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.dismiss-error {
	background: none;
	border: none;
	color: #721c24;
	font-size: 1.2rem;
	cursor: pointer;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
}

.dismiss-error:hover {
	background: rgba(220, 53, 69, 0.1);
}

.add-key-section {
  margin-bottom: 1em;
}

.input-group {
  display: flex;
  gap: 0.5em;
  align-items: center;
}

.key-input {
  flex: 1 1;
  padding: 0.5em;
  border: 1px solid #505050;
  border-radius: 4px;
  background-color: #282c34;
  color: white;
  font-size: 11pt;
}

.key-input:focus {
  outline: none;
  border-color: #61dafb;
}

.key-input:disabled {
	background: #f8f9fa;
	color: #6c757d;
	cursor: not-allowed;
}

.add-button {
  padding: 0.5em 1em;
  background-color: #61dafb;
  color: #282c34;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11pt;
  font-weight: bold;
}

.add-button:hover {
  background-color: #81faff;
}

.add-button:disabled {
  background-color: #505050;
  color: #888;
  cursor: not-allowed;
}

.keys-list {
  margin-top: 1em;
}

.no-keys {
  text-align: center;
  padding: 2em;
  color: #999;
}

.no-keys p {
  margin: 0.5em 0;
}

.help-text {
  font-size: 0.9em;
  color: #777;
}

.keys-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
}

.keys-header h4 {
  margin: 0;
  color: #e0e0e0;
  font-size: 1.2rem;
}

.keys-actions {
  display: flex;
  gap: 0.5em;
}

.refresh-button,
.clear-all-button {
  padding: 0.5em 1em;
  border: 1px solid #444;
  border-radius: 4px;
  background: #3a3a3a;
  color: #e0e0e0;
  cursor: pointer;
  font-size: 11pt;
  transition: all 0.2s ease;
}

.refresh-button:hover,
.clear-all-button:hover {
  background: #4a4a4a;
  border-color: #555;
}

.clear-all-button {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.clear-all-button:hover {
  background: #c82333;
  border-color: #c82333;
}

.key-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1em;
  border: 1px solid #444;
  border-radius: 6px;
  margin-bottom: 1em;
  background: #2a2a2a;
  transition: all 0.2s ease;
}

.key-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.key-info {
  flex: 1 1;
}

.key-value {
  display: block;
  font-family: monospace;
  font-size: 1.1em;
  color: #e0e0e0;
  margin-bottom: 0.5em;
  word-break: break-all;
}

.key-details {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  align-items: center;
}

.key-status {
  padding: 0.25em 0.5em;
  border-radius: 12px;
  font-size: 0.8em;
  font-weight: 500;
  text-transform: uppercase;
}

.key-status.valid {
	background: #d4edda;
	color: #155724;
}

.key-status.stale {
	background: #fff3cd;
	color: #856404;
}

.key-status.expired {
	background: #f8d7da;
	color: #721c24;
}

.key-status.invalid {
  color: #f00;
}

.key-status.pending {
  color: #ffa500;
}

.key-type {
  color: #def;
}

.key-expiry {
  color: #bcd;
}

.key-error {
	background: #f8d7da;
	color: #721c24;
	padding: 8px 12px;
	border-radius: 4px;
	font-size: 12px;
	border-left: 3px solid #dc3545;
	margin-top: 8px;
}

.key-last-response {
	background: #e2e3e5;
	color: #495057;
	padding: 8px 12px;
	border-radius: 4px;
	font-size: 11px;
	border-left: 3px solid #6c757d;
	word-break: break-all;
	max-height: 100px;
	overflow-y: auto;
	margin-top: 8px;
}

.remove-button {
  padding: 0.25em 0.5em;
  background-color: transparent;
  color: #f00;
  border: 1px solid #f00;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11pt;
  margin-left: 1em;
}

.remove-button:hover {
  background-color: #f00;
  color: white;
}

.remove-button:disabled {
  border-color: #505050;
  color: #505050;
  cursor: not-allowed;
}

.license-keys-loading {
	text-align: center;
	padding: 40px;
	color: #6c757d;
	font-size: 1.1rem;
}

@media (max-width: 768px) {
	.license-keys {
		padding: 15px;
	}
	
	.input-group {
		flex-direction: column;
		align-items: stretch;
	}
	
	.keys-header {
		flex-direction: column;
		align-items: stretch;
		gap: 15px;
	}
	
	.keys-actions {
		justify-content: center;
	}
	
	.key-item {
		flex-direction: column;
		align-items: stretch;
		gap: 15px;
	}
	
	.key-details {
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;
	}
	
	.remove-button {
		margin-left: 0;
		align-self: flex-end;
	}
}
`, "",{"version":3,"sources":["webpack://./src/containers/Licensing/LicenseKeys.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,cAAc;CACd,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,UAAU;CACV,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,mBAAmB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,8BAA8B;CAC9B,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,8BAA8B;CAC9B,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;CACV;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;CACV;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;CACT;;CAEA;EACC,cAAc;EACd,oBAAoB;CACrB;AACD","sourcesContent":[".license-keys {\n\tmax-width: 800px;\n\tmargin: 0 auto;\n\tpadding: 20px;\n}\n\n.license-keys h3 {\n\tmargin-bottom: 20px;\n\tcolor: #333;\n\tfont-size: 1.5rem;\n}\n\n.error-message {\n\tbackground: #f8d7da;\n\tcolor: #721c24;\n\tborder: 1px solid #f5c6cb;\n\tborder-radius: 6px;\n\tpadding: 15px;\n\tmargin-bottom: 20px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.dismiss-error {\n\tbackground: none;\n\tborder: none;\n\tcolor: #721c24;\n\tfont-size: 1.2rem;\n\tcursor: pointer;\n\tpadding: 0;\n\twidth: 24px;\n\theight: 24px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n}\n\n.dismiss-error:hover {\n\tbackground: rgba(220, 53, 69, 0.1);\n}\n\n.add-key-section {\n  margin-bottom: 1em;\n}\n\n.input-group {\n  display: flex;\n  gap: 0.5em;\n  align-items: center;\n}\n\n.key-input {\n  flex: 1;\n  padding: 0.5em;\n  border: 1px solid #505050;\n  border-radius: 4px;\n  background-color: #282c34;\n  color: white;\n  font-size: 11pt;\n}\n\n.key-input:focus {\n  outline: none;\n  border-color: #61dafb;\n}\n\n.key-input:disabled {\n\tbackground: #f8f9fa;\n\tcolor: #6c757d;\n\tcursor: not-allowed;\n}\n\n.add-button {\n  padding: 0.5em 1em;\n  background-color: #61dafb;\n  color: #282c34;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11pt;\n  font-weight: bold;\n}\n\n.add-button:hover {\n  background-color: #81faff;\n}\n\n.add-button:disabled {\n  background-color: #505050;\n  color: #888;\n  cursor: not-allowed;\n}\n\n.keys-list {\n  margin-top: 1em;\n}\n\n.no-keys {\n  text-align: center;\n  padding: 2em;\n  color: #999;\n}\n\n.no-keys p {\n  margin: 0.5em 0;\n}\n\n.help-text {\n  font-size: 0.9em;\n  color: #777;\n}\n\n.keys-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1em;\n}\n\n.keys-header h4 {\n  margin: 0;\n  color: #e0e0e0;\n  font-size: 1.2rem;\n}\n\n.keys-actions {\n  display: flex;\n  gap: 0.5em;\n}\n\n.refresh-button,\n.clear-all-button {\n  padding: 0.5em 1em;\n  border: 1px solid #444;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: #e0e0e0;\n  cursor: pointer;\n  font-size: 11pt;\n  transition: all 0.2s ease;\n}\n\n.refresh-button:hover,\n.clear-all-button:hover {\n  background: #4a4a4a;\n  border-color: #555;\n}\n\n.clear-all-button {\n  background: #dc3545;\n  color: white;\n  border-color: #dc3545;\n}\n\n.clear-all-button:hover {\n  background: #c82333;\n  border-color: #c82333;\n}\n\n.key-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1em;\n  border: 1px solid #444;\n  border-radius: 6px;\n  margin-bottom: 1em;\n  background: #2a2a2a;\n  transition: all 0.2s ease;\n}\n\n.key-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.key-info {\n  flex: 1;\n}\n\n.key-value {\n  display: block;\n  font-family: monospace;\n  font-size: 1.1em;\n  color: #e0e0e0;\n  margin-bottom: 0.5em;\n  word-break: break-all;\n}\n\n.key-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5em;\n  align-items: center;\n}\n\n.key-status {\n  padding: 0.25em 0.5em;\n  border-radius: 12px;\n  font-size: 0.8em;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.key-status.valid {\n\tbackground: #d4edda;\n\tcolor: #155724;\n}\n\n.key-status.stale {\n\tbackground: #fff3cd;\n\tcolor: #856404;\n}\n\n.key-status.expired {\n\tbackground: #f8d7da;\n\tcolor: #721c24;\n}\n\n.key-status.invalid {\n  color: #f00;\n}\n\n.key-status.pending {\n  color: #ffa500;\n}\n\n.key-type {\n  color: #def;\n}\n\n.key-expiry {\n  color: #bcd;\n}\n\n.key-error {\n\tbackground: #f8d7da;\n\tcolor: #721c24;\n\tpadding: 8px 12px;\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\tborder-left: 3px solid #dc3545;\n\tmargin-top: 8px;\n}\n\n.key-last-response {\n\tbackground: #e2e3e5;\n\tcolor: #495057;\n\tpadding: 8px 12px;\n\tborder-radius: 4px;\n\tfont-size: 11px;\n\tborder-left: 3px solid #6c757d;\n\tword-break: break-all;\n\tmax-height: 100px;\n\toverflow-y: auto;\n\tmargin-top: 8px;\n}\n\n.remove-button {\n  padding: 0.25em 0.5em;\n  background-color: transparent;\n  color: #f00;\n  border: 1px solid #f00;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11pt;\n  margin-left: 1em;\n}\n\n.remove-button:hover {\n  background-color: #f00;\n  color: white;\n}\n\n.remove-button:disabled {\n  border-color: #505050;\n  color: #505050;\n  cursor: not-allowed;\n}\n\n.license-keys-loading {\n\ttext-align: center;\n\tpadding: 40px;\n\tcolor: #6c757d;\n\tfont-size: 1.1rem;\n}\n\n@media (max-width: 768px) {\n\t.license-keys {\n\t\tpadding: 15px;\n\t}\n\t\n\t.input-group {\n\t\tflex-direction: column;\n\t\talign-items: stretch;\n\t}\n\t\n\t.keys-header {\n\t\tflex-direction: column;\n\t\talign-items: stretch;\n\t\tgap: 15px;\n\t}\n\t\n\t.keys-actions {\n\t\tjustify-content: center;\n\t}\n\t\n\t.key-item {\n\t\tflex-direction: column;\n\t\talign-items: stretch;\n\t\tgap: 15px;\n\t}\n\t\n\t.key-details {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tgap: 8px;\n\t}\n\t\n\t.remove-button {\n\t\tmargin-left: 0;\n\t\talign-self: flex-end;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
